import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/camarero-1-tomar-pedido.webp")